import React, { useEffect, useState } from "react";
import TimeIcon from "assets/svgIcons/TimeIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import moment from "moment";
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE, UPDATED_CAR_DATA_STATE } from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const CarRoundStatus = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
    const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);
    const [carsInStagingArea, setCarsInStagingArea] = useState([]);
    const {
        getPreRoundCarsState,
        getTournSettingsState,
        siteSettingsData,
        getDashboardFeatureSetStatus,
        siteSetupData
    } = useSelector((state) => state?.commonReducers) || [];

    useEffect(() => {
        if (getDashboardFeatureSetStatus === API_STATUSES.SUCCESS && siteId.get() !== null &&
            siteSettingsData &&Object.keys(siteSettingsData).length > 0) {
            const lastQueryDate = moment(new Date())
                .utc()
                .utcOffset(-siteSettingsData?.TimeZoneOffset)
                .format("YYYY-MM-DD");

            dispatch(
                COMMON_SERVICES.getPreRoundCarsServices(
                    siteId.get(),
                    lastQueryDate,
                    localStorage.getItem("dashCourseId")
                )
            );
            dispatch(
                COMMON_SERVICES.getTournSettingsServices(
                    siteId.get(),
                    true,
                    true,
                    true
                )
            );
            dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
        }
    }, [
        getDashboardFeatureSetStatus,
        siteId.get(),
        localStorage.getItem("dashCourseId"),
        siteSettingsData,
    ]);

    const pointInPolygon = (point, polygon, longitudePropertyName, latitudePropertyName) => {
        var x = point[0], y = point[1];
        var inside = false;
        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            var xi = polygon[i][longitudePropertyName], yi = polygon[i][latitudePropertyName];
            var xj = polygon[j][longitudePropertyName], yj = polygon[j][latitudePropertyName];

            var intersect = ((yi > y) != (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }
        return inside;
    }
    
    function isCarOnStagingArea(car) {
        let point = [car?.Car?.Longitude, car?.Car?.Latitude];
        for (let i = 0; i < siteSetupData?.SiteAreas?.length; i++) {
            if (pointInPolygon(point, siteSetupData?.SiteAreas[i]?.Polygon, "Lon", "Lat")) {
                return true;
            }
        }
        return false;
    }

    useEffect(() => {
        let carsData = [];
        if (updatedCarData.get() && updatedCarData.get().length > 0) {
            carsData = JSON.parse(updatedCarData.get());
        }
        var carsInStagingArea = carsData.filter((car) => {
            return isCarOnStagingArea(car);
        });
        setCarsInStagingArea(carsInStagingArea);
    }, [siteSetupData, updatedCarData.get()]);

    return (
        <>
            <div className="header">
                <TimeIcon width={25} height={20} />
                <p>{t("Car_Round_Status")}</p>
            </div>
            <div className="box-body car-round-status">
                <ul>
                    <li>
                        <p>{t("On_course")}</p>
                        <p>{getPreRoundCarsState && getPreRoundCarsState?.CarsOnCourse}</p>
                    </li>
                    <li>
                        <p>{t("On_charge")}</p>
                        <p>
                            {getPreRoundCarsState && getPreRoundCarsState?.CarsOnCharging}
                        </p>
                    </li>
                    <li>
                        <p>{t("In_Staging_Area")}</p>
                        <p>{carsInStagingArea && carsInStagingArea.length}</p>
                    </li>
                    {getTournSettingsState && Object.keys(getTournSettingsState).length > 0 && <li>
                        <p>{t("In_tournament")}</p>
                        <p>
                            {moment(getTournSettingsState[0]?.EndDate).format('YYYY-MM-DD') > moment().subtract(1, 'day').format('YYYY-MM-DD') ? getTournSettingsState[0]?.CarSettings?.length : 0}
                        </p>
                    </li>}
                    <li>
                        <p>{t("Out_of_service")}</p>
                        <p>
                            {getPreRoundCarsState && getPreRoundCarsState?.CarsOutOfService}
                        </p>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default CarRoundStatus;
